<template>
  <div class="nursingArrangeplan">
    <el-row style="
        height: 54px;
        line-height: 54px;
        background: #f9f7fa;
        border: 1px #f1eff2 solid;
        margin-top: 10px;">
      <el-col>
        <span><img src="@/assets/beadhouse/juxing.png" alt="" style="vertical-align: middle; margin: 0 10px" /></span>
        <span style="font-size: 18px; margin-right: 15px">{{
          nursingArrangePlan.arrangePlan
        }}</span>
        <span><kt-button icon="el-icon-plus" :label="nursingArrangePlan.addPlan" type="warning"
            @click="handleAddProject" /></span>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <div v-for="(item, index) in forEachTableList" :key="index">
        <div v-if="item.isUsed > 0" class="isused">
          {{ nursingArrangePlan.use }}
        </div>
        <el-table style="width: 100%" :data="item.shiftsList" :row-style="tableRowStyle"
          :header-cell-style="tableHeaderColor">
          <el-table-column :label="item.name" style="height: 65px" align="center" min-width="120"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-input v-if="scope.row.edit" v-model.trim="scope.row.name" style="width: 60%"
                :placeholder="nursingArrangePlan.pleaseEnterShiftName"
                @change="handleChange(scope.row.id, scope.row.name)"></el-input>
              <span v-show="!scope.row.edit" style="margin-left: 10px">{{
                scope.row.name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="nursingArrangePlan.shiftTime" style="height: 65px" align="center" min-width="150"
            :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-time-picker v-show="scope.row.edit" v-model="scope.row.startTime"
                :placeholder="nursingArrangePlan.startTime" format="HH:mm:ss" value-format="HH:mm:ss" style="width: 120px"
                clear-icon="el-icon-circle-close" @change="
                  handleChangeStartTime(scope.row.id, scope.row.startTime)
                  ">
              </el-time-picker>
              <span v-show="scope.row.edit">-</span>
              <el-time-picker v-show="scope.row.edit" v-model="scope.row.endTime"
                :placeholder="nursingArrangePlan.endTime" format="HH:mm:ss" value-format="HH:mm:ss" style="width: 120px"
                clear-icon="el-icon-circle-close" @change="handleChangeEndTime(scope.row.id, scope.row.endTime)">
              </el-time-picker>
              <span v-show="!scope.row.edit">{{ scope.row.time }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="nursingArrangePlan.whetherToTakeOver" style="height: 65px" align="center"
            min-width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-select v-show="scope.row.edit" :disabled="item.isUsed > 0" v-model="scope.row.shifts" style="width: 30%"
                @change="handleChangeShifts(scope.row.id, scope.row.shifts)" placeholder="">
                <el-option v-for="item in shiftingOfDutyOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <span v-show="!scope.row.edit && scope.row.shifts == 1" style="margin-left: 10px">{{ nursingArrangePlan.yes
              }}</span>
              <span v-show="!scope.row.edit && scope.row.shifts == 0" style="margin-left: 10px">{{ nursingArrangePlan.no
              }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="nursingArrangePlan.operation" min-width="100" align="center" style="height: 65px">
            <template slot-scope="scope">
              <el-button type="warning" plain size="mini" @click="handleEditProject(index, scope.row)">编辑</el-button>
              <el-button type="danger" plain size="mini" v-show="item.isUsed == 0"
                @click="handleDeleteProject(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div align="center" style="margin: 40px 0 50px 0">
          <kt-button v-show="item.id == scopePlanId" label="保存" type="primary" @click="handleSavebyId(item.id)" />
          <kt-button v-show="item.id == scopePlanId" label="取消" @click="handleCancelbyId(item.id)" />
          <kt-button v-show="item.isUsed == 0 && scopePlanId == ''" label="删除" type="warning"
            @click="handleDeleteById(item.id)" />
        </div>
      </div>
    </el-row>
    <!-- 新增排班方案的dialog模态框-->
    <el-dialog class="addProject" :title="nursingArrangePlan.addArrangePlan" width="55%"
      :visible.sync="addProjectDialogVisible" :close-on-click-modal="false" @close="closeAddProject">
      <el-form :model="addProjectForm" label-width="120px" :rules="addProjectFormRules" ref="addProjectForm" :size="size"
        label-position="right">
        <el-form-item :label="nursingArrangePlan.arrangePlanName" prop="projectName">
          <el-col>
            <el-input v-model.trim="addProjectForm.projectName" auto-complete="off"
              :placeholder="nursingArrangePlan.pleaseEnterSchedulingSchemeName" style="width: 30%"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <el-row style="height: 54px; line-height: 54px">
        <el-col>
          <span style="margin: 0 5px 0 35px">排班班次</span>
          <span><img src="@/assets/beadhouse/tj1.png" alt=""
              style="vertical-align: middle; margin: 0 10px; cursor: pointer" @click="addPlanTable" /></span>
          <span><img src="@/assets/beadhouse/cz1.png" alt="" style="vertical-align: middle; cursor: pointer"
              @click="resetPlanTable" /></span>
        </el-col>
      </el-row>
      <el-table style="width: 100%" :data="addProjectList" :row-style="tableRowStyle"
        :header-cell-style="tableHeaderColor">
        <el-table-column :label="nursingArrangePlan.classesName" style="height: 65px" align="center" min-width="120"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="scope.row.edit">
              <el-input v-model.trim="scope.row.lengthOfShift" style="width: 60%"
                :placeholder="nursingArrangePlan.pleaseEnterShiftName"></el-input>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="nursingArrangePlan.shiftTime" style="height: 65px" align="center" min-width="150"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="scope.row.edit">
              <el-time-picker v-model="scope.row.addProjectStartTime" :placeholder="nursingArrangePlan.startTime"
                format="HH:mm:ss" value-format="HH:mm:ss" style="width: 120px" clear-icon="el-icon-circle-close">
              </el-time-picker>
              <span>-</span>
              <el-time-picker v-model="scope.row.addProjectEndTime" :placeholder="nursingArrangePlan.endTime"
                format="HH:mm:ss" value-format="HH:mm:ss" style="width: 120px" clear-icon="el-icon-circle-close">
              </el-time-picker>
            </template>
          </template>
        </el-table-column>
        <el-table-column :label="nursingArrangePlan.whetherToTakeOver" style="height: 65px" align="center" min-width="100"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <template v-if="scope.row.edit">
              <el-select v-model="scope.row.shiftingOfDuty" style="width: 35%">
                <el-option v-for="item in shiftingOfDutyOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="addProjectDialogVisible = false">取消</el-button>
        <el-button :size="size" type="primary" @click.native="submitFormAddProjectForm"
          :loading="addProjectFormLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
export default {
  name: "NursingArrangePlan",
  components: { KtTable, KtButton },
  data() {
    return {
      nursingArrangePlan: {
        arrangePlan: "排班方案",
        addPlan: "新增方案",
        pleaseEnterShiftName: "请输入班次名称",
        shiftTime: "班次时间",
        startTime: "开始时间",
        endTime: "结束时间",
        whetherToTakeOver: "是否交接班",
        yes: "是",
        no: "否",
        operation: "操作",
        addArrangePlan: "新增排班方案",
        arrangePlanName: "排班方案名称:",
        pleaseEnterSchedulingSchemeName: "请输入排班方案名称",
        classesName: "班次名",
        use: "使用中",
        notEmpty: "不能为空",
        messageLenOnetoFive: "长度在 1到 5 的字符",
        messagePlanNameNoEmpty: "班次名称不能为空",
        messagePlanNameNotThanFive: "班次名称不能超过5个字符",
        messagePlanTimeNoEmpty: "班次时间不能为空"
      }, //引入 lang 里面的字符串资源,
      size: "medium", //按钮的尺寸
      addProjectForm: {
        projectName: "",
      },
      addProjectFormLoading: false,
      addProjectFormRules: {
        projectName: [
          {
            required: true,
            message: "不能为空",
            trigger: "blur",
          },
          {
            min: 1,
            max: 5,
            message: "长度在 1到 5 的字符",
          },
        ],
      },
      addProjectDialogVisible: false,
      addProjectList: [
        {
          lengthOfShift: "",
          addProjectStartTime: "",
          addProjectEndTime: "",
          shiftingOfDuty: 1,
          edit: true,
        },
        {
          lengthOfShift: "",
          addProjectStartTime: "",
          addProjectEndTime: "",
          shiftingOfDuty: 1,
          edit: true,
        }
      ], //新增排班方案dialog中的表格数据,edit为true时就显示该行数据
      shiftsList: [], //新增方案提交的数据
      lengthOfShift: "", //班次名
      shiftingOfDuty: 0, //默认为 是
      addProjectStartTime: "00:00:00",
      addProjectEndTime: "23:59:59",
      shiftingOfDutyOptions: [
        { label: "是", value: 1 },
        { label: "否", value: 0 },
      ],
      forEachTableList: [], //循环动态添加的的多个表格数据,
      oneTableList: [], //单个排班计划的数据
      scopePlanId: "",
    };
  },
  methods: {
    /* 
            新增排班方案的dialog
        */
    handleAddProject() {
      this.addProjectDialogVisible = true;
      //清除验证和值
      this.$nextTick(() => {
        if (this.$refs.addProjectForm) {
          this.$refs.addProjectForm.resetFields();
        }
      });
    },

    /* 
            关闭新增排班方案的dialog
        */
    closeAddProject() {
      this.addProjectList = [
        {
          lengthOfShift: "",
          addProjectStartTime: "",
          addProjectEndTime: "",
          shiftingOfDuty: 1,
          edit: true,
        },
        {
          lengthOfShift: "",
          addProjectStartTime: "",
          addProjectEndTime: "",
          shiftingOfDuty: 1,
          edit: true,
        }
      ];
    },

    /* 
            点击加号新增table中的行
        */
    addPlanTable() {
      console.log(this.addProjectList);
      let editObj = {
        lengthOfShift: "",
        addProjectStartTime: "",
        addProjectEndTime: "",
        shiftingOfDuty: 1,
        edit: true,
      };
      this.addProjectList.push(editObj);
    },

    /* 
            排班班次名 
        */
    handleChange(id, name) {
      console.log(id, name);
    },

    /* 
            排班开始时间
        */
    handleChangeStartTime(id, startTime) {
      console.log(id, startTime);
    },

    /* 
            排班结束时间
        */
    handleChangeEndTime(id, endTime) {
      console.log(id, endTime);
    },

    /* 
            是否交接班
        */
    handleChangeShifts(id, shifts) {
      console.log(id, shifts);
    },

    /* 
            表格的编辑按钮
        */
    handleEditProject(index, row) {
      console.log(index, row, this.forEachTableList);
      //by guo 2020-7-1-16:18添加  通过两次循环判断不是当前点击的表格的可编辑状态都重置为初始状态
      this.forEachTableList.forEach((item, i) => {
        console.log(i);
        if (i != index) {
          item.shiftsList.forEach((temp) => {
            this.$set(temp, "edit", false);
          });
        }
      });
      //row.edit=true;//element-ui 2.4.11版本 此写法修改状态可以更新视图
      this.$set(row, "edit", true); //element-ui 2.4.11 版本更新后 到2.11.1之后 不能用上面的哪一种写法  不会自动更新视图的
      this.scopePlanId = row.planid;
      console.log(row.planid);
      this.getOnePlan(row.planid);
    },

    /* 
            表格的取消按钮
        */
    handleCancelbyId(id) {
      console.log(id);
      this.getArrangePlan(0);
      this.scopePlanId = ""; //清空值，让取消按钮隐藏
    },

    /* 
            删除整个table
        */
    handleDeleteById(planId) {
      this.$confirm("你确定要删除吗？", "请确认信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$postJson("omc/plan/delete/" + planId).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.message,
              });
            } else {
              this.$message({
                type: "error",
                message: res.message,
              });
            }
            this.getArrangePlan(0);
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    /* 
            查询单个排班计划
        */
    getOnePlan(id) {
      let params = {};
      params.id = id; //id传0时是查询所有的
      this.$postJson("omc/plan/queryListAll", params).then((res) => {
        console.log(res);
        this.oneTableList = [];
        res.result.forEach((item) => {
          var onePlanObj = {};
          onePlanObj.id = item.id;
          onePlanObj.name = item.name;
          onePlanObj.isUsed = item.isUsed;
          item.shiftsList.forEach((temp) => {
            temp.edit = false;
            temp.startTime = temp.time.split("-")[0];
            temp.endTime = temp.time.split("-")[1];
          });
          onePlanObj.shiftsList = item.shiftsList;
          this.oneTableList.push(onePlanObj);
        });
        console.log(this.oneTableList);
      });
    },

    /* 
            编辑排班方案的保存提交数据
        */
    handleSavebyId(id) {
      console.log(id);
      console.log("xxxxxx", this.forEachTableList);
      var params = {}; //提交的数据
      var shiftsList = []; //用来存放提交的数据的数组
      this.forEachTableList.forEach((item) => {
        //第一层循环 判断点击的id是否和当前table的id相同
        if (id == item.id) {
          params.name = item.name; //获取提交的数据name
          params.isUsed = item.isUsed; //获取提交的数据isUseed  大于0是使用中的  不可删除   等于0的是未使用中  可以删除
          item.shiftsList.forEach((temp) => {
            var oneTableObj = {};
            oneTableObj.id = temp.id;
            oneTableObj.name = temp.name;
            oneTableObj.time = temp.startTime + "-" + temp.endTime;
            oneTableObj.shifts = temp.shifts;
            shiftsList.push(oneTableObj);
          });
        }
      });
      params.id = id;
      params.shiftsList = shiftsList;
      console.log(params);
      if (this.checkPlanNoEmpty(params.shiftsList) != false) {
        this.$postJson("omc/plan/edit", params).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.getArrangePlan(0);
            this.scopePlanId = ""; //清空值，让保存按钮隐藏
          } else {
            this.$message({ message: res.message, type: "error" });
          }
        });
      }
    },

    /* 
            验证排班班次名和时间
        */
    checkPlanNoEmpty(list) {
      for (var i = 0; i < list.length; i++) {
        if (
          list[i].name == "" ||
          list[i].name == undefined ||
          list[i].name == null
        ) {
          this.$message({
            message: this.nursingArrangePlan.messagePlanNameNoEmpty,
            type: "error",
          });
          return false;
        } else if (list[i].name.length > 5) {
          this.$message({
            message: this.nursingArrangePlan.messagePlanNameNotThanFive,
            type: "error",
          });
          return false;
        } else if (
          list[i].time == "-" ||
          list[i].time == undefined ||
          list[i].time == null
        ) {
          this.$message({
            message: this.nursingArrangePlan.messagePlanTimeNoEmpty,
            type: "error",
          });
          return false;
        }
      }
    },

    /* 
            表格中的未使用的单个删除  
        */
    handleDeleteProject(index, row, id) {
      console.log(index, row, id);
      console.log(this.forEachTableList);
      var params = {}; //提交的数据
      var shiftsList = []; //用来存放提交的数据的数组
      this.forEachTableList.forEach((item) => {
        //第一层循环 判断点击的id是否和当前table的id相同
        if (id == item.id) {
          params.name = item.name; //获取提交的数据name
          params.isUsed = item.isUsed; //获取提交的数据isUseed  大于0是使用中的  不可删除   等于0的是未使用中  可以删除
          //第二层循环获取shiftsList数组
          item.shiftsList.forEach((temp) => {
            var oneTableObj = {};
            if (row.id !== temp.id) {
              //row.id为table点击的该行的id ,row.id==temp.id，就是需要删除的数据 ，把需要提交的数据添加进对象，最后push到shiftsList数组中
              oneTableObj.id = temp.id;
              oneTableObj.name = temp.name;
              oneTableObj.time = temp.startTime + "-" + temp.endTime;
              oneTableObj.shifts = temp.shifts;
              shiftsList.push(oneTableObj);
            }
          });
        }
      });
      params.id = id;
      params.shiftsList = shiftsList;
      console.log(params);
      this.$confirm("你确定要删除吗？", "请确认信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        //修改删除接口  by xiang
        this.$postJson("omc/plan/deleteShiftById/" + row.id).then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
          } else {
            this.$message({ message: res.message, type: "error" });
          }
          this.getArrangePlan(0); //传0是获取全部的数据
          this.scopePlanId = ""; //清空值，让保存按钮隐藏
        });
      });
    },

    /* 
            新增排班方案
        */
    submitFormAddProjectForm() {
      this.$refs.addProjectForm.validate((valid) => {
        if (valid) {
          console.log(this.addProjectList);
          let params = {};
          params.name = this.addProjectForm.projectName; //新增排班方案的名称
          params.shiftsList = this.filterAddProject(); //获取新增排班方案需要提交的数组
          console.log(params);
          //console.log(this.checkPlanNoEmpty(params.shiftsList))
          if (this.checkPlanNoEmpty(params.shiftsList) != false) {
            this.addProjectFormLoading = true;
            this.$postJson("omc/plan/add", params).then((res) => {
              console.log(res);
              this.addProjectFormLoading = false;
              if (res.code == 200) {
                this.$message({ message: "操作成功", type: "success" });
                this.addProjectDialogVisible = false;
                //请求成功之后将数组重置为初始数据，以防止累加
                this.addProjectList = [
                  {
                    lengthOfShift: "",
                    addProjectStartTime: "",
                    addProjectEndTime: "",
                    shiftingOfDuty: 1,
                    edit: true,
                  },
                  {
                    lengthOfShift: "",
                    addProjectStartTime: "",
                    addProjectEndTime: "",
                    shiftingOfDuty: 1,
                    edit: true,
                  }
                ];
              } else {
                this.$message({
                  message: "操作失败, " + res.message,
                  type: "error",
                });
              }
              this.getArrangePlan(0);
            });
          }
        }
      });
    },

    /* 
            过滤新增排班的数据
        */
    filterAddProject() {
      console.log(this.addProjectList);
      this.shiftsList = []; //将数据清空，防止数据累加
      this.addProjectList.forEach((item) => {
        console.log(item);
        let shiftsObj = {};
        shiftsObj.name = item.lengthOfShift;
        shiftsObj.time =
          item.addProjectStartTime + "-" + item.addProjectEndTime;
        shiftsObj.shifts = item.shiftingOfDuty;
        this.shiftsList.push(shiftsObj);
      });
      return this.shiftsList;
    },

    /* 
            查询所有的排班计划   
        */
    getArrangePlan(id) {
      let params = {};
      params.id = id; //id传0时是查询所有的
      this.$postJson("omc/plan/queryListAll", params).then((res) => {
        console.log(res);
        this.forEachTableList = res.result;
        this.forEachTableList.forEach((item) => {
          item.shiftsList.forEach((temp) => {
            //temp.edit=false;//element-ui 2.4.11版本 此写法修改状态可以更新视图
            this.$set(temp, "edit", false); //element-ui 2.4.11 版本更新后 到2.11.1之后 不能用上面的哪一种写法  不会自动更新视图的
            //temp.startTime=temp.time.split('-')[0];
            this.$set(temp, "startTime", temp.time.split("-")[0]);
            //temp.endTime=temp.time.split("-")[1];
            this.$set(temp, "endTime", temp.time.split("-")[1]);
          });
        });
      });
    },

    /* 
            重置table中的初始值
        */
    resetPlanTable() {
      this.addProjectList = [
        {
          lengthOfShift: "",
          addProjectStartTime: "",
          addProjectEndTime: "",
          shiftingOfDuty: 1,
          edit: true,
        },
        {
          lengthOfShift: "",
          addProjectStartTime: "",
          addProjectEndTime: "",
          shiftingOfDuty: 1,
          edit: true,
        }
      ];
    },

    /* 
            修改table tr行的背景色
       */
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },

    /* 
            修改table header的背景色
        */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
  },
  mounted() {
    this.getArrangePlan(0); //id传0时是查询所有的
  },
  watch: {
    oneTableList: {
      handler(newValue, oldValue) {
        console.log(newValue);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.nursingArrangeplan {
  min-width: 1360px;
  min-height: 500px;
  background: #fefefe;

  .isused {
    color: red;
    margin-left: 10px;
  }
}

// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

//新增排班方案的的dialog模态框
::v-deep .addProject .el-dialog .el-dialog__body {
  padding: 10px 20px 30px 20px;
  height: 450px;
  overflow-y: scroll;
}
</style>
